module.exports = __webpack_public_path__ + "img/clip-1439.00e9b6fe.png";